import { render, staticRenderFns } from "./UserDropdown.vue?vue&type=template&id=7b701752"
import script from "./UserDropdown.js?vue&type=script&lang=js&external"
export * from "./UserDropdown.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports